import {
  Notifications,
  People,
  School,
  Computer,
  Map,
  List as ListIcon,
} from "@mui/icons-material";

// Curated icon set for Quick Links — deliberately not a free-form picker
// (icon upload, full library search), so the Home page grid stays visually
// consistent no matter who adds a link. Keep in sync with the backend's
// QuickLinkController::ALLOWED_ICONS.
export const QUICK_LINK_ICONS = {
  notifications: Notifications,
  list: ListIcon,
  school: School,
  people: People,
  computer: Computer,
  map: Map,
};

export const QUICK_LINK_ICON_OPTIONS = [
  { name: "notifications", label: "Notifications" },
  { name: "list", label: "List" },
  { name: "school", label: "School" },
  { name: "people", label: "People" },
  { name: "computer", label: "Computer" },
  { name: "map", label: "Map" },
];

export const renderQuickLinkIcon = (icon, props = { fontSize: "large" }) => {
  const IconComponent = QUICK_LINK_ICONS[icon] || QUICK_LINK_ICONS.list;
  return <IconComponent {...props} />;
};
